// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TSetEmailTagsRequestPayload,
  TSetEmailTagsResponsePayload,
  TSetTagsRequestPayload,
  TSetTagsResponsePayload,
} from './tagging.types.ts';

export const createTaggingApi = (transport: TApiTransport) => ({
  /** Sets tags for an email */
  setEmailTags: (
    payload: TSetEmailTagsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TSetEmailTagsRequestPayload, TSetEmailTagsResponsePayload>(
      '/set_email_tags',
      payload,
      options,
    ),

  /** Sets the user's tags */
  setTags: (payload: TSetTagsRequestPayload, options?: TApiRequestOptions) =>
    transport.post<TSetTagsRequestPayload, TSetTagsResponsePayload>(
      '/set_tags',
      payload,
      options,
    ),
});
